import React from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "reactstrap";
import { bindActionCreators } from "redux";
import { authenticationAction } from "../../_actions";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

const AccountMenu = ({logout}:any) => {
  const { t } = useTranslation();

  return (
    <ul className="menu down-menu">
      <li>
        <NavLink
          className="menu-link"
          activeClassName="active-link"
          to="/settings"
        >
          <div>
          <i>
              <svg
                style={{ width: "24px", height: "24px" }}
                viewBox="0 0 24 24"
              >
                <path
                  fill="#ffffff"
                  d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"
                />
              </svg>
            </i>
            <span>{t("menu:settings")}</span>
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="menu-link"
          to="/"
          onClick={() => logout()}
        >
          <div>
          <i>
              <svg
                style={{ width: "24px", height: "24px", transform: "rotate(180deg)" }}
                viewBox="0 0 24 24"
              >
                <path
                  fill="#ffffff"
                  d="M19,3H5C3.89,3 3,3.89 3,5V9H5V5H19V19H5V15H3V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M10.08,15.58L11.5,17L16.5,12L11.5,7L10.08,8.41L12.67,11H3V13H12.67L10.08,15.58Z"
                />
              </svg>
            </i>
            <span>{t("menu:logout")}</span>
          </div>
        </NavLink>
      </li>
    </ul>
  );
};

const mapDispatchToProps = (dispatch:any) => {
  return bindActionCreators({
    logout: authenticationAction.logout,
  }, dispatch)
};

const AccountMenuComponent = connect(null, mapDispatchToProps)(AccountMenu);

export { AccountMenuComponent as AccountMenu };